<p>
  {{data.title}}
</p>
<div class="margin-bottom-20px">
  <mat-divider></mat-divider>
</div>
<div>{{data.message}}</div>